
import { formatDate } from "../../Types/formatDate";
import useFetchBookingsByOrderNumber from "./fetchBookingsByOrderNumber"


const TestFetchBookingsByOrderNumber = () => {

    const bookingsByOrderNumber = useFetchBookingsByOrderNumber("ORD-RAJAMAA-638626030683479002");

    

    if (bookingsByOrderNumber.loading) {
        return <p>Loading...</p>;
    }
    return (
        <div>
            {bookingsByOrderNumber.error && <p>{bookingsByOrderNumber.error}</p>}
            <h2>Bookings by Order Number</h2>
            <ul>
                {bookingsByOrderNumber.bookings.map((booking) => (
                    <li key={booking.bookingId}>{booking.bookingId}
                    <div>{booking.orderNumber}</div>
                    <div>{booking.customerName}</div>
                    <div>{formatDate(booking.arrivalDate.toString(), 'sv-SE')}</div>
                    <div>{formatDate(booking.departureDate.toString(), 'sv-SE')}</div>
                  <div>{booking.invoiceURL}</div>
                    <div>{booking.totalCost}</div>

                    </li>
                   

                ))}
            </ul>
        </div>
    );
}

export default TestFetchBookingsByOrderNumber;